function Icon({ color, size }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 29 28'
    >
      <path
        fill={color}
        d='M9.663 13.206a.873.873 0 01-.392-1.658l9.211-4.605a.875.875 0 01.782 1.564l-9.211 4.605a.87.87 0 01-.39.094zM19.517 21.474a.88.88 0 01-.39-.093l-10.501-5.25a.875.875 0 11.782-1.564l10.5 5.25a.875.875 0 01-.391 1.657z'
        opacity='0.4'
      />
      <path
        fill={color}
        d='M7.5 17.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM21.5 10.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM21.5 24.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z'
      />
    </svg>
  );
}

export default Icon;
